import { result } from 'lodash';
import Qua from '@tencent/parse-qua'
import cookies from 'js-cookie';
import { userCenterUrl } from '@tencent/qb-article-util/lib/urlHelper';

/**
 * 获取url参数
 */
const queryCache = new Map();
function query(key, url) {
    if (queryCache.has(key)) {
      return queryCache.get(key)
    }

    var reg = new RegExp("(^|&|\\?|#|&amp;)" + key + "=([^&#]*)(&|$|#)", "");
    url = url || document.location.href;
    if (typeof url === "undefined") {
        queryCache.set(key, url)
        return;
    }
    var match = url.match(reg);
    if (match) {
        queryCache.set(key, match[2])
        return match[2];
    }
    queryCache.set(key, '')
    return "";
}

const refer = query('refer')

let env = null;
const detectEnv = () => {
    if (env) return env;

    const ua = navigator.userAgent;
    let platform = '';
    let isIos = false;
    let isAndroid = false;
    let isWeChat = false;
    let isMQQ = false;
    let isWxwork = false;

    if (/android\s+(\S+);/i.test(ua)) {
        platform = 'android';
        isAndroid = true;
    } else if (/(?:ipad|iphone|ipod).*os\s+(\S+)\s+like\s+mac\s+os/i.test(ua)) {
        platform = 'ios';
        isIos = true;
    }

    if(/wxwork/i.test(ua)) {
        isWxwork = true;
    } else if (/MicroMessenger/i.test(ua)) {
        isWeChat = true;
    } else if (/\/[\w. ]+QQ\//i.test(ua)) {
        isMQQ = true;
    }

    const isQQLive = /\/[\w. ]+QQLiveBrowser\//i.test(ua);
    const isQZone = /Qzone/i.test(ua);
    const isTBS = /TBS\//i.test(ua);
    const isQB =
        (!!(window.browser && window.browser.login) || /\/[\w. ]+MQQBrowser\//i.test(ua)) &&
        !isWxwork &&
        !isWeChat &&
        !isMQQ &&
        !isQQLive;
    // 排除腾讯视频

    env = {
        isWeChat,
        isMQQ,
        isQZone,
        isQB,
        platform,
        isIos,
        isAndroid,
        isQQLive,
        isTBS,
        isWxwork,
    };
    return env;
};

const getShareParams = function(route = {}) {
    const sDocId = getArticleIdFromUrl()
      || getVideoIdFromUrl()
      || result(route, 'computedMatch.params.id', window.location.pathname.split('news/')[1])
      || result(route, 'computedMatch.params.id', window.location.pathname.split('shortContent/')[1])

    const url = query('url')
    const ch = query('ch')
    const dataSrc = query('dataSrc')

    const shSid = query('sh_sid') || ''
    const shareParams = shSid.split('__')
    const actType = shareParams[0] || 0;
    let sUserId = shareParams.length > 0 ? shareParams[1] : shareParams[0];
    let sGuid = shareParams.length > 1 ? shareParams[2] : '';

    // 快报用户信息
    if (query('from_app') === 'kb' || query('from_app') === 'qqkd'){
        sUserId = query('sUserId') || ''
        sGuid = query('sGuid') || ''
    }

    return {
        sDocId,
        sUserId,
        ch,
        url,
        actType,
        sGuid,
        dataSrc,
        shSid
    }
}

const isQehId = (id = '') => /^qeh_/.test(id) // 判断是否是企鹅号

const getPersonalUrl = function (params = {}) {
    let pars = params;
    if (window && window.navigator.userAgent) {
      const ua = window.navigator.userAgent;
      const quaObj = new Qua(ua);
      pars = Object.assign(params, {
        qbVersion: quaObj.version,
        platform: quaObj.platForm === 'ADR' ? 1 : 2,
        env: window.location.href.indexOf('sparta') > -1 ? 'test' : ''
      });
    }
    return userCenterUrl && userCenterUrl(pars);
}

const number2percent = function (number) {
    if (typeof number !== 'number') {
      return number;
    }
    return `${number * 100}%`;
}

const getImageDimension = function (src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
      image.onerror = reject;
      image.src = src; // start loading
    });
}
const parseJSON = function (response) {
    const url = response.url || '';
    return response.text()
      .then(text => {
        if (text.length) {
          try {
            return JSON.parse(text);
          } catch (error) {
            console.log(`fetch reponse,url:${url}`, error);
            return {};
          }
        }
    });
}

const checkStatus = function (response = {}) {
    if (response && response.status >= 200 && response.status < 300) {
      return response;
    }
    return parseJSON(response)
      .catch(e => undefined)
      .then(body => {
        const error = new Error(response.statusText);
        error.response = response;
        error.body = body;
        if (body && body.message) {
          error.message = body.message;
        }
        throw error;
    });
}

const setData = function(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.setItem(name, value);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.setItem(name, value);
        }
    } catch(e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.set(name, value);
    }

    return ''
}

const getData = function(name, value, options) {
    if (options) {
        if (options.storage === 'sessionStorage') {
            return window.sessionStorage.getItem(name);
        }
    }

    try {
        if ('localStorage' in window && window.localStorage !== null) {
            return window.localStorage.getItem(name);
        }
    } catch(e) {
        console.log(e)
        return
    }

    if (window.nativeStorage) {
        return window.nativeStorage.get(name);
    }
}

let userKey = null
const getUserKey = function () {
    if (userKey) return userKey;

    let key = getData('user_key');
    if (key) {
        userKey = key;
        return key;
    }

    let cUserKey = cookies.get('user_key');
    if (cUserKey) {
        console.debug('cookie user_key', cUserKey);
        setData('user_key', cUserKey);
        return cUserKey;
    }

    let d = +new Date();
    d =  [d, Math.floor(d * Math.random() * Math.random()).toString().slice(-5)].join('');
    setData('user_key', d);
    userKey = d;
    return d;
}

const getArticleIdFromUrl = () => {
  return query('docId') || window.location.pathname.split('/news/')[1]
}

/**
 * @desc 返回页插入、监听方法
 *
 * @param {*} url
 * @param {*} callback
 */
const initLocationBackPage = (url, callback, useSelfPage = false) => {
  window.history.pushState(null, null, '#');
  window.addEventListener('popstate', async (e) => {
    if (useSelfPage) {
      // 使用自有页面，则利用router replace
      callback && await callback()
      return
    }
    if (url) {
      callback && await callback();
      window.location.replace(url);
    }
  }, false);
}

const getVideoIdFromUrl = () => {
    return query('docId') || query('vid') || window.location.pathname.split('/video/')[1];
}

const getdocIdFromUrl = () => {
  return query('docId')
}

const parseQueryString = function (str) {
    let ret = {};
    if (!str) {
        ret = {}
    } else {
        let arr = str.split('&');
        arr.forEach(function (item) {
            let tmpArr = item.split('=');
            ret[tmpArr[0]] = tmpArr[1];
        })
    }
    return ret;
}

const reactClassSet = function (classNames) {
    if (typeof classNames === "object") {
        return Object.keys(classNames).filter(function (className) {
            return classNames[className];
        }).join(" ");
    } else {
        return Array.prototype.join.call(arguments, " ");
    }
};


//对播放量、评论数等做统一的格式化
const formatCount = function(playCount) {
    if (!playCount) {
        return "";
    }
    playCount = parseInt(playCount);
    playCount = playCount.toFixed(1);
    if (playCount >= 100000000) {
        return Math.ceil(playCount / 10000000) / 10 + "亿";
    } else if (playCount >= 10000) {
        return Math.ceil(playCount / 1000) / 10 + "万";
    } else {
        return Math.ceil(playCount);
    }
}

//对iRuntime统一处理
//iRuntime单位秒
const formatRuntime = function (iRuntime) {
    let ret = "00:15";
    iRuntime = parseInt(iRuntime || 0);
    if (iRuntime) {
        let arr = [];
        if (iRuntime >= 3600) {
            let hour = parseInt(iRuntime / 3600);
            arr.push(hour);
            iRuntime = iRuntime % 3600;
        }
        if (iRuntime >= 60) {
            let minute = parseInt(iRuntime / 60);
            arr.push(minute);
            iRuntime = iRuntime % 60;
        } else {
            arr.push("00");
        }
        arr.push(iRuntime);
        let newArr = [];
        arr.forEach((item) => {
            if( (item + '').length <= 1) {
                item = '0' + item;
            }
            newArr.push(item);
        });
        ret = newArr.join(":");
    }
    return ret;
}

const stopScroll = (e) => {
  e.stopPropagation();
 // e.preventDefault();
};

const addStopScrollListener = () => {
  // 监听滚动
  document.addEventListener('touchmove', stopScroll, { passive: false });
  document.body.style.top = '0';
  document.body.style.position = 'fixed';
  document.body.style.height = '100%';
  document.body.style.overflow = 'hidden';
}

const delStopScrollListener = () => {
  // 移除监听滚动
  document.removeEventListener('touchmove', stopScroll, { passive: true });
  document.body.style.position = 'initial';
  document.body.style.overflowY = 'auto';
}


export {
    query,
    refer,
    detectEnv,
    getShareParams,
    isQehId,
    getPersonalUrl,
    number2percent,
    getImageDimension,
    parseJSON,
    checkStatus,
    getData,
    setData,
    getUserKey,
    getArticleIdFromUrl,
    initLocationBackPage,
    getVideoIdFromUrl,
    parseQueryString,
    reactClassSet,
    formatCount,
    formatRuntime,
    getdocIdFromUrl,
    addStopScrollListener,
    delStopScrollListener
}
